import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { YoutubeDownloadLogEntry, YoutubeDownloadLogStatus, YoutubeSourceResponse, YoutubeSourceService } from '../../../services/youtube-source.service';

@Component({
	selector: 'app-youtube-download-log',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		MatFormFieldModule,
		MatSelectModule,
		MatTableModule,
		MatPaginatorModule,
		MatIconModule,
		MatProgressSpinnerModule,
	],
	templateUrl: './youtube-download-log.component.html',
	styleUrl: './youtube-download-log.component.scss',
})
export class YoutubeDownloadLogComponent implements OnInit {
	readonly displayedColumns = ['DATE', 'SOURCE', 'TITLE', 'STATUS'];
	readonly statusOptions: YoutubeDownloadLogStatus[] = [
		'DOWNLOADED',
		'SKIPPED_NO_SUBTITLES',
		'SKIPPED_NO_KEYWORD',
		'SKIPPED_OLD',
		'ALREADY_EXISTS',
		'ERROR',
	];

	dataSource = new MatTableDataSource<YoutubeDownloadLogEntry>();
	sources: YoutubeSourceResponse[] = [];
	loading = false;
	totalElements = 0;
	pageSize = 20;
	pageIndex = 0;

	selectedSourceId: string | null = null;
	selectedStatus: YoutubeDownloadLogStatus | null = null;

	constructor(private apiYoutubeSource: YoutubeSourceService) {}

	ngOnInit(): void {
		this.apiYoutubeSource
			.getSources()
			.pipe(take(1))
			.subscribe(sources => (this.sources = sources));
		this.loadLog();
	}

	onFilterChange(): void {
		this.pageIndex = 0;
		this.loadLog();
	}

	onPageChange(event: PageEvent): void {
		this.pageIndex = event.pageIndex;
		this.pageSize = event.pageSize;
		this.loadLog();
	}

	private loadLog(): void {
		this.loading = true;
		this.apiYoutubeSource
			.searchDownloadLog({ sourceId: this.selectedSourceId, status: this.selectedStatus }, this.pageIndex, this.pageSize)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.dataSource.data = response.content || [];
					this.totalElements = response.totalElements;
					this.loading = false;
				},
				error: () => {
					this.loading = false;
				},
			});
	}
}
